// dashboardApi.js
import httpClient from '../../../shared/services/httpClient';

const dashboardApi = {
  // Get all patients with optional filters
  getOHCDashboard: async () => {
    const response = await httpClient.get(`/ohcs/dashboard`);
    return response.data;
  }


};
export default dashboardApi;